import { render, staticRenderFns } from "./EnvVarsBlock.vue?vue&type=template&id=5370aaaa&scoped=true&"
import script from "./EnvVarsBlock.vue?vue&type=script&lang=js&"
export * from "./EnvVarsBlock.vue?vue&type=script&lang=js&"
import style0 from "./EnvVarsBlock.vue?vue&type=style&index=0&id=5370aaaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370aaaa",
  null
  
)

export default component.exports